import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

import { isKeywordGraphApp } from '../appVariant'

// The page's horizontal gutter was left-only — `pl` here on top of the
// <main> `marginLeft` in Apps.jsx, with nothing setting a right one. Above
// ~864px the 800px cap hides that; on a phone the text and the longer links
// ran straight into the viewport edge. `pl` drops on xs so the two sides
// match the 32px the <main> margin already provides.
const SECTION_SX = {
    pt: 8,
    pb: 4,
    pl: { xs: 0, sm: '32px' },
    pr: 4,
    maxWidth: '800px',
}

export default function AppsOutroSection() {
    return (
        <>
            <Box sx={SECTION_SX}>
                <Divider
                    variant="middle"
                    textAlign="left"
                    sx={{ ml: 0, marginBottom: 2 }}
                />
                <Typography
                    component="h5"
                    variant="h5"
                    align="left"
                    color="text.primary"
                >
                    {isKeywordGraphApp()
                        ? 'Use KeywordGraph in Your Favorite LLM Client via MCP Server'
                        : 'Use InfraNodus in Your Favorite LLM Client via MCP Server'}
                    <br></br>
                    &nbsp;
                </Typography>

                <Typography
                    component="subtitle1"
                    variant="subtitle1"
                    align="left"
                    color="text.primary"
                >
                    You can use InfraNodus knowledge graph insights to enhance
                    your LLM reasoning via the MCP server in Claude Web, Claude
                    Code, ChatGPT, Cursor AI, etc.
                    <br></br>
                    <br></br>•{' '}
                    <a href="/mcp" target="_blank">
                        More about the MCP server
                    </a>{' '}
                    — detailed information about the InfraNodus MCP server
                    <br></br>•{' '}
                    <a
                        href="https://support.noduslabs.com/hc/en-us/articles/24549263125788-How-to-Install-the-InfraNodus-MCP-Server"
                        target="_blank"
                    >
                        One-click deployment via mcp.infranodus.com
                    </a>{' '}
                    —  best for Claude Web and ChatGPT
                    <br></br>•{' '}
                    <a
                        href="https://github.com/infranodus/mcp-server-infranodus"
                        target="_blank"
                    >
                        Local deployment via our GitHub repository
                    </a>{' '}
                     — for technical users and local development
                    <br></br>
                    <br></br>
                    You will need to get the{' '}
                    <a href="/api-access" target="_blank">
                        API key from InfraNodus
                    </a>{' '}
                    to authenticate.
                </Typography>
            </Box>
            <Box sx={SECTION_SX}>
                <Divider
                    variant="middle"
                    textAlign="left"
                    sx={{ ml: 0, marginBottom: 2 }}
                />
                <Typography
                    component="h5"
                    variant="h5"
                    align="left"
                    color="text.primary"
                >
                    {isKeywordGraphApp()
                        ? 'Doing a Research or Need More Applications?'
                        : 'Try the InfraNodus Extension and Obsidian Plugin'}
                    <br></br>
                    &nbsp;
                </Typography>

                <Typography
                    component="subtitle1"
                    variant="subtitle1"
                    align="left"
                    color="text.primary"
                >
                    Generate research questions and insightful ideas from your
                    own content, web content, Google Docs, PDFs, and YouTube
                    videos with the new 3D graph interface. Save the most
                    interesting insights to your InfraNodus graphs.
                    <br></br>
                    <br></br>•{' '}
                    <a href="/extension" target="_blank">
                        Browser extension
                    </a>{' '}
                    — analyze search results, web pages, YouTube videos, ChatGPT
                    chats
                    <br></br>•{' '}
                    <a href="/obsidian-plugin" target="_blank">
                        Obsidian graph view plugin
                    </a>{' '}
                    —  apply to your personal knowledge management system
                    <br></br>•{' '}
                    <a href="/vscode-extension" target="_blank">
                        IDE (Cursor AI, VSCode, Antigravity) extension
                    </a>{' '}
                     — use on your markdown and HTML files as well as codebases.
                </Typography>
            </Box>

            <Box sx={{ ...SECTION_SX, pb: 8 }}>
                <Divider
                    variant="middle"
                    textAlign="left"
                    sx={{ ml: 0, marginBottom: 2 }}
                />
                <Typography
                    component="h5"
                    variant="h5"
                    align="left"
                    color="text.primary"
                >
                    {isKeywordGraphApp()
                        ? 'Want to Know the Science Behind KeywordGraph?'
                        : 'Want to Know the Science Behind InfraNodus?'}
                    <br></br>
                    &nbsp;
                </Typography>

                <Typography
                    component="subtitle1"
                    variant="subtitle1"
                    align="left"
                    color="text.primary"
                >
                    The methods used in this tool are outlined in the following
                    research paper, which you can use for citations:
                    <br></br>
                    <br></br>
                    <em>
                        Paranyushkin, D (2019). InfraNodus: Generating Insight
                        Using Text Network Analysis, Proceeding WWW'19, The
                        World Wide Web Conference, 3584-3589, San Francisco (
                        <a href="http://bit.ly/infrasiteacm" rel="nofollow">
                            ACM library
                        </a>
                        , <a href="http://bit.ly/infrapdfhomepage">PDF</a>)
                    </em>{' '}
                    <br></br>
                    <br></br>
                    The earlier work using this methodology can be found on{' '}
                    <a href="https://noduslabs.com/publications/">
                        Nodus Labs publications
                    </a>{' '}
                    page.
                    <br></br>
                </Typography>
            </Box>
        </>
    )
}
